import React from 'react';
import { Route, Switch } from 'react-router-dom';
import constants from 'utils/constants';
import PaymentsConfirmation from 'components/widgets/payments/web/PaymentsConfirmation';
import EmployeePayments from 'components/employeePayments/EmployeePayments';
import ModifyPayment from 'components/modifyPayment/ModifyPayment';
import ManageImportMaps from 'components/widgets/wireImports/manage/manageImportMaps';
import WireImportActionSwitcher from 'components/widgets/wireImports/WireImportActionSwitcher';
import PaymentsWorkspace from 'components/paymentsWorkspace/PaymentsWorkspace';
import ACHRoutes from './ACHRoutes';
import WireRoutes from './WireRoutes';
import LoanRoutes from './LoanRoutes';

const { PYMTCNTR } = constants.WORKSPACES;
// Routes under /payments url

const PaymentRoutes = () => (
  <Switch>
    <Route path={`${PYMTCNTR}/ach`} component={ACHRoutes} />
    <Route path={`${PYMTCNTR}/wires`} component={WireRoutes} />
    <Route path={`${PYMTCNTR}/loans`} component={LoanRoutes} />
    <Route path={`${PYMTCNTR}/confirm`} component={PaymentsConfirmation} exact />
    <Route path={`${PYMTCNTR}/modify/:bankTrace`} component={ModifyPayment} exact />
    <Route path={`${PYMTCNTR}/managePaymentMap`} component={ManageImportMaps} exact />
    managePaymentMap
    <Route path={`${PYMTCNTR}/employee-payments/:action/:id`} component={EmployeePayments} />
    <Route
      path={`${PYMTCNTR}/managePaymentMap/:action(\\w+)?/:mapType?/:id?`}
      component={WireImportActionSwitcher}
    />
    <Route path={`${PYMTCNTR}`} component={PaymentsWorkspace} />
    {/* TODO: Add 404 page specific to missing routes in payments */}
    {/* If you only want to render one of these routes then put them in a Switch component */}
    {/* <Route component={() => <h1>Can be a specific to payment center missing routes</h1>} /> */}
  </Switch>
);

export default PaymentRoutes;
